import previewPage from '@internal/i18n/messages/preview-page'
import temboUsersPage from '@internal/i18n/messages/tembo-users'
import analyticsPage from '@internal/i18n/messages/analytics'
import alertsPage from '@internal/i18n/messages/alerts'
import residentsPages from '@internal/i18n/messages/residents-pages'
import visits from '@internal/i18n/messages/visits'
import root from '@internal/i18n/messages/root'
import settings from '@internal/i18n/messages/settings'
import notificationsPage from '@internal/i18n/messages/notifications'
import tasksPage from '@internal/i18n/messages/tasks'
import locationsPage from '@internal/i18n/messages/locations'

const messages = {
  en: {
    ...previewPage.en,
    ...temboUsersPage.en,
    ...analyticsPage.en,
    ...alertsPage.en,
    ...residentsPages.en,
    ...visits.en,
    ...root.en,
    ...settings.en,
    ...notificationsPage.en,
    ...tasksPage.en,
    ...locationsPage.en,
  },
}

export default messages
